import { Css } from "@homebound/beam";
import { QueryResultHandler } from "src/components";
import { PlanBasedLineItemsTabQuery, usePlanBasedLineItemsTabQuery } from "src/generated/graphql-types";
import { PlanBasedBidLinesTable } from "./PlanBasedBidLinesTable";
import { ScopeLinesTable } from "./ScopeLinesTable";

type PlanBasedLineItemsSectionProps = {
  commitmentId: string;
};

export function PlanBasedLineItemsSection(props: PlanBasedLineItemsSectionProps) {
  const query = usePlanBasedLineItemsTabQuery({ variables: { commitmentId: props.commitmentId } });
  return QueryResultHandler<PlanBasedLineItemsTabQuery>({
    result: query,
    render: ({ commitment: c }) => (
      <div css={Css.df.fdc.gap2.$}>
        <PlanBasedBidLinesTable
          planBasedLineItems={c.bidContractRevision?.planBasedLineItems ?? []}
          lineItems={c.lineItems}
        />
        <ScopeLinesTable lineItems={c.lineItems} />
      </div>
    ),
  });
}
